import fetch from '../../../utils/fetch';
import { giftCodeURL } from 'endpoints';
import { message } from 'antd';
import { startLoading, endLoading } from '../../../app-dux/app-dux';
import serviceAwardsSdk from '../../../services/service-awards-sdk';
import getCompanyVariable from '../../../utils/get-company-variable';
import { downloadDepositFile } from '../../../utils/download.js';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    giftCodes: null,
    expiredAt: '',
    programData: [],
    selectedGiftCodes: [],
    disableConvertButton: true
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_GIFT_CODES_DATA = 'SET_GIFT_CODES_DATA';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const TOGGLE_SELECTED_GIFT_CODE_DATA = 'TOGGLE_SELECTED_GIFT_CODE_DATA';
export const SET_PROGRAM_DATA = 'SET_PROGRAM_DATA';
export const UPDATE_GIFT_CODE = 'UPDATE_GIFT_CODE';
export const DISABLE_CONVERT_BUTTON = 'DISABLE_CONVERT_BUTTON';

/*******************************************************************************
 * Reducer
 */
export default function giftCodesSearchPageReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_GIFT_CODES_DATA:

            const newGiftCodes = [];
            const existingGiftCodes = state.giftCodes ? [ ...state.giftCodes ] : [];

            let updatedGiftCodes = existingGiftCodes.map( giftCode => giftCode );

            action.data.map( ( g ) => {
                const issuedTo = `${ g.firstName || '' } ${ g.lastName || '' }`;
                newGiftCodes.push( {
                    giftCodeId: g.giftCodeId,
                    giftCode: g.giftCode,
                    referenceNumber: g.referenceNumber,
                    programNumber: g.programNumber,
                    level: g.levelName,
                    issuedAt: g.issuedAt,
                    expiredAt: g.expiredAt,
                    firstName: g.firstName || '',
                    lastName: g.lastName || '',
                    issuedTo: issuedTo,
                    status: g.status,
                    selected: false
                } );
            } );

            if ( existingGiftCodes.length > 0 && action.status === 'updateData' ) {
                newGiftCodes.map( ngc => {
                    const index = existingGiftCodes.findIndex( gc => ngc.giftCodeId === gc.giftCodeId );

                    if ( index == -1 ) {
                        updatedGiftCodes.push( ngc );
                    } else {
                        updatedGiftCodes[ index ] = ngc;
                    }
                } );
            } else {
                updatedGiftCodes =  newGiftCodes;
            }

            return {
                ...state,
                giftCodes: updatedGiftCodes
            };

        case UPDATE_GIFT_CODE:
            return {
                ...state,
                expiredAt: action.date,
                status: action.status
            };

        case TOGGLE_SELECTED_GIFT_CODE_DATA:
            return {
                ...state,
                selectedGiftCodes: action.selectedRows,
            };
        
        case DISABLE_CONVERT_BUTTON:
            return {
                ...state,
                disableConvertButton: action.value,
            };

        case CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                giftCodes: []
            };

        case SET_PROGRAM_DATA:
            return {
                ...state,
                programData: action.programData
            };

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

export const fetchGiftCodes = ( reqObj ) => async ( dispatch ) => {
    const qry = Object.keys( reqObj )
        .filter( ( key ) => !!reqObj[ key ] &&  reqObj[ key ] !== '' && reqObj[ key ] !== 'all' )
        .map( ( key ) =>
            `${ encodeURIComponent( key ) }=${ encodeURIComponent( reqObj[ key ] ) }`
        )
        .join( '&' );

    dispatch( startLoading() );

    try {
        const res = await fetch( `${ giftCodeURL }/gift-codes?${ qry }` );

        const data = await res.json();

        if ( res.ok ) {
            dispatch( setGiftCodesData( data, 'setData' ) );

            return data;
        } else {
            throw data;
        }
    } catch ( err ) {
        console.error( 'Error While fetching gift codes:', err );
        let errorMessage = 'Something went wrong fetching gift codes';
        if ( err?.message ) {
            errorMessage = err.message;
        } else if ( err?.errors?.length > 0 && err?.errors[ 0 ]?.message ) {
            errorMessage = err?.errors[ 0 ]?.message;
        }
        message.error( errorMessage );
    } finally {
        dispatch( endLoading() );
    }
};

export function getGiftCodeStatus( giftCodeId ) {
    return ( resolve ) => {
        return fetch( `${ giftCodeURL }/giftCode/${ giftCodeId }/status` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        return data;
                    } );
                    return res;
                } else {
                    res.json().then( ( data ) => {
                        resolve( data.responseMessage );
                    } );
                }
            } );
    };
}


export const updateGiftCodes = ( action, searchObj ) => async( dispatch, getState ) => {

    const state = getState();

    const giftCodeIds = state.giftCodesSearchPage.selectedGiftCodes;

    const reqObj = {
        action,
        'pid': getCompanyVariable( state?.company?.activeCompany?.variableList, 'PID' ),
        giftCodeIds: giftCodeIds
    };

    const date = new Date();

    if ( giftCodeIds && giftCodeIds.length > 0 ) {
        switch ( action ) {

            case 'expire':
                Object.assign( reqObj, { expiredAt: state.giftCodesSearchPage.expiredAt, statusUpdatedAt: date } );

                break;

            case 'cancel':
                Object.assign( reqObj, { status: 'Cancelled', statusUpdatedAt: date } );

                break;

            case 'cancel-reissue':
                Object.assign( reqObj, { status: 'Cancelled', statusUpdatedAt: date } );

                break;

            case 'return-reissue':
                if ( giftCodeIds.length > 1 ) {
                    message.info( 'Please select one giftcode at a time for this action.', 4 );
                    return;
                }
                Object.assign( reqObj, { status: 'Redeemed', statusUpdatedAt: date } );

                break;

            case 'convert':
                Object.assign( reqObj, { status: 'Converted', statusUpdatedAt: date } );
        
                break; 

            default:
                break;

        }
    }

    dispatch( startLoading() );
    if ( action === 'convert' ) {
        try {
            const res = await fetch( `${ giftCodeURL }/gift-codes`, {
                method: 'PATCH',
                headers: { 
                    'content-type': 'application/json', 
                    'accept-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'x-accept-encoding': 'base64'
                },
                body: JSON.stringify( reqObj )
            } );

            if ( res.ok ) {
                const data = await res.text();
                downloadDepositFile( data, 'deposit.xlsx' );
                const searchResults = await dispatch( fetchGiftCodes( searchObj ) ) ;
                dispatch( setGiftCodesData( searchResults, 'updateData' ) );
                dispatch( onSelectedRowChange( [] ) );
                message.success( 'Success' );
            } else {
                let errorMessage = 'Something went wrong while updating gift codes';
                if ( res?.message ) {
                    errorMessage = res.message;
                } else if ( res?.errors?.length > 0 && res?.errors[ 0 ]?.message ) {
                    errorMessage = res?.errors[ 0 ]?.message;
                }
                alert( errorMessage );
            }

        } catch ( err ) {
            console.log( 'Error while patching gift code', err );
        }
        finally {
            dispatch( endLoading() );
        }
    } else {
        try {
            const res = await fetch( `${ giftCodeURL }/gift-codes`, {
                method: 'PATCH',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( reqObj )
            } );
        
            const data = await res.json();

            if ( res.ok ) {
                dispatch( setGiftCodesData( data, 'updateData' ) );
                dispatch( onSelectedRowChange( [] ) );
                dispatch( onChangeExpDate( null ) );
                if ( action === 'return-reissue' && data[ 0 ].newReferenceNumber ) {
                    message.success( `Successfully Reissued with new reference number ${ data[ 0 ].newReferenceNumber } ` );
                } else {
                    message.success( 'Success' );
                }
                return data;
            } else {
                let errorMessage = 'Something went wrong while updating gift codes';
                if ( data?.message ) {
                    errorMessage = data.message;
                } else if ( data?.errors?.length > 0 && data?.errors[ 0 ]?.message ) {
                    errorMessage = data?.errors[ 0 ]?.message;
                }
                alert( errorMessage );
        }
        } catch ( err ) {
            console.log( 'Error while patching gift code', err );
        }
        finally {
            dispatch( endLoading() );
        }
    }
};

export function loadPrograms( ) {
    return ( dispatch ) => {
      return serviceAwardsSdk.getPrograms ()
      .then( ( programs ) => {
        dispatch( setProgramData( programs ) );
      } )
      .catch( ( errors ) => {
          console.log( errors );
      } );
    };
 
}
 
function setProgramData( programData ) {
    return {
        type: SET_PROGRAM_DATA,
        programData
    };
}

export function onChangeExpDate( date ) {
    return {
        type: UPDATE_GIFT_CODE,
        date
    };
}

export function setGiftCodesData( data, status ) {
    return {
        type: SET_GIFT_CODES_DATA,
        data,
        status
    };
}

export const onSelectedRowChange = ( selectedRows ) => ( dispatch, getState ) => {
    const state = getState();
    const giftCodes = state.giftCodesSearchPage.giftCodes;
    const selectedCodes = [];
    selectedRows.forEach( selectedCodeId => {
        const selectedCode = giftCodes.find( code => code.giftCodeId === selectedCodeId );
        selectedCodes.push( selectedCode );
    } );
    const checkEnableButton = ( selectedCodes ) => {
        for ( let i = 0; i < selectedCodes.length; i++ ) {
            if ( ( selectedCodes[ i ].status != 'Issued' && selectedCodes[ i ].status != 'ReIssued' ) || selectedCodes[ i ].issuedTo === ' ' ) {
                dispatch( { 
                    type: DISABLE_CONVERT_BUTTON,
                    value: true
                } );
                return;
            } else {
                dispatch( { 
                    type: DISABLE_CONVERT_BUTTON,
                    value: false
                } );
            }
        }
    };
    checkEnableButton( selectedCodes );
    dispatch( {
        type: TOGGLE_SELECTED_GIFT_CODE_DATA,
        selectedRows,
    } );
};

export function onClearSearchResults() {
    return {
        type: CLEAR_SEARCH_RESULTS
    };
}